// utils/dateFormatter.js
import React from "react";

/**
 * Format date for display with colored date/time
 */
export const formatDateTimeJSX = (value) => {
  if (!value) return "-";

  const date = new Date(value);
  if (isNaN(date.getTime())) return "-";
          const day = (date.getUTCDate() < 10 ? "0" : "") + date.getUTCDate();
          const month =
            (date.getUTCMonth() + 1 < 10 ? "0" : "") + (date.getUTCMonth() + 1);
          const year = date.getUTCFullYear();
          const hours =
            (date.getUTCHours() < 10 ? "0" : "") + date.getUTCHours();
          const minutes =
            (date.getUTCMinutes() < 10 ? "0" : "") + date.getUTCMinutes();
          const seconds =
            (date.getUTCSeconds() < 10 ? "0" : "") + date.getUTCSeconds();

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <span style={{ color: "blue", fontSize: "calc(0.5rem + 0.2vw)" }}>
        {`${day}/${month}/${year}`}
      </span>
      <span style={{ color: "green", fontSize: "calc(0.5rem + 0.2vw)" }}>
        {`${hours}:${minutes}:${seconds}`}
      </span>
    </div>
  );
};

/**
 * Format date for CSV export (prevents Excel auto-formatting)
 */
export const formatDateForCSV = (dateStr) => {
  if (!dateStr) return "";

  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return "";

  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const year = date.getUTCFullYear();
  const hours = String(date.getUTCHours()).padStart(2, "0");
  const minutes = String(date.getUTCMinutes()).padStart(2, "0");
  const seconds = String(date.getUTCSeconds()).padStart(2, "0");

  // Prevent Excel from changing format
  return `="\t${day}/${month}/${year} ${hours}:${minutes}:${seconds}"`;
};

/**
 * Format date for API requests
 */
export const formatDateForAPI = (date) => {
  if (!date) return "";

  const dayjs = require("dayjs");
  return dayjs(date).isValid() ? dayjs(date).format("YYYY-MM-DD HH:mm") : "";
};
